import Splash from './pages/Splash';
import Home from "./pages/Home";
import Chat from "./pages/Chat";
import Profile from "./pages/Profile";
import Round from "./pages/rounds/Round";
import Login from "./pages/auth/Login";
import PasswordRequest from "./pages/auth/PasswordRequest";
import NotFound from "./pages/NotFound";
import Stand from "@/pages/stands/Stand";
import Investment from "@/pages/investments/Investment";
import Farming from "@/pages/farming/Farming";
import AdminHome from "@/pages/admin/AdminHome";
import ChatMessages from "@/pages/ChatMessages";
import UserManagement from "@/pages/admin/UserManagement";
import Dashboard from "@/pages/admin/Dashboard";
import AdminCreateUser from "@/pages/admin/AdminCreateUser";
import AdminCreateProject from "@/pages/admin/AdminCreateProject";
import AdminProjectList from "@/pages/admin/AdminProjectList";
import AdminChat from "@/pages/admin/AdminChat";
import AdminProfile from "@/pages/admin/AdminProfile";
import Book from "@/pages/Book";
import SingleRound from "@/pages/rounds/SingleRound";
import SingleStand from "@/pages/stands/SingleStand";
import SingleFarmingProject from "@/pages/farming/SingleFarmingProject";
import SingleInvestment from "@/pages/investments/SingleInvestment";
import Course from "@/pages/courses/Course";
import SingleCourse from "@/pages/courses/SingleCourse";
import Video from "@/pages/courses/Video";
import Update from "@/pages/news/Update";
import SingleUpdate from "@/pages/news/SingleUpdate";
import NewPrayer from "@/pages/prayers/NewPrayer";
import NewQuery from "@/pages/queries/NewQuery";

export const routes = [{
        path: '/',
        name: "Splash",
        component: Splash
    },
    {
        path: '/home',
        name: "Home",
        component: Home
    },
    {
        path: '/prayers',
        name: "NewPrayer",
        component: NewPrayer
    },
    {
        path: '/query',
        name: "NewQuery",
        component: NewQuery
    },
    {
        path: '/book',
        name: "Book",
        component: Book
    },
    {
        path: '/chat',
        name: "Chat",
        component: Chat
    },
    {
        path: '/chat/:type/:id',
        name: "ChatMessages",
        component: ChatMessages
    },
    {
        path: '/profile',
        name: "Profile",
        component: Profile
    },
    {
        path: '/round',
        name: "Round",
        component: Round
    },
    {
        path: '/stand',
        name: "Stand",
        component: Stand
    },
    {
        path: '/investment',
        name: "Investment",
        component: Investment
    },
    {
        path: '/course',
        name: "Course",
        component: Course
    },
    {
        path: '/farming',
        name: "Farming",
        component: Farming
    },
    {
        path: '/round/:id',
        name: "SingleRound",
        component: SingleRound
    },
    {
        path: '/stand/:id',
        name: "SingleStand",
        component: SingleStand
    },
    {
        path: '/projects/:id',
        name: "SingleFarmingProject",
        component: SingleFarmingProject
    },
    {
        path: '/investment/:id',
        name: "SingleInvestment",
        component: SingleInvestment
    },
    {
        path: '/course/:id',
        name: "SingleCourse",
        component: SingleCourse
    },
    {
        path: '/course_video',
        name: "Video",
        component: Video
    },
    {
        path: '/login',
        name: "Login",
        component: Login
    },
    {
        path: '/password',
        name: "PasswordRequest",
        component: PasswordRequest
    },
    {
        path: '/update',
        name: "Update",
        component: Update
    },
    {
        path: '/update/:id',
        name: "SingleUpdate",
        component: SingleUpdate
    },
    {
        path: '/admin',
        name: "AdminHome",
        component: AdminHome,
        children: [
            {
                path: 'profile',
                name: "AdminProfile",
                component:AdminProfile
            },
            {
                path: '/',
                name: "Dashboard",
                component: Dashboard
            },
            {
                path: 'chat/:type/:id',
                name: "AdminChat",
                component: AdminChat
            },
            {
                path: 'users',
                name: "UserManagement",
                component: UserManagement
            },
            {
                path: 'users/new',
                name: "AdminCreateUser",
                component: AdminCreateUser
            },
            {
                path: 'new/:type',
                name: "AdminCreateProject",
                component: AdminCreateProject
            },
            {
                path: 'list/:type',
                name: "AdminProjectList",
                component: AdminProjectList
            }
        ]
    },
    {
        path: '/*',
        component: NotFound
    },
    {
        path:'/round/item',
        component: SingleRound
    }
]